import { IconProps } from './Icon.types'
import { RootIcon } from './Icon.styles'
import { getColorFromString } from '../../utils/Helper'
import { useTheme } from 'styled-components'
import React from 'react'

const CustomIcon = ({ color = 'black', size = 16, ...props }: IconProps) => {
    const theme = useTheme()
    const height = typeof size === 'number' ? size : size.height
    const width = typeof size === 'number' ? size : size.width
    const fillColor = getColorFromString(theme, color)

    return (
        <RootIcon
            {...props}
            $width={width}
            $height={height}
            viewBox={`0 0 ${width} ${height}`}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <circle cx='12' cy='6.69548' r='1.80029' fill={fillColor} />
            <circle cx='12' cy='12' r='1.80029' fill={fillColor} />
            <circle cx='12' cy='17.3045' r='1.80029' fill={fillColor} />
        </RootIcon>
    )
}

export default CustomIcon
